const TYPE = "ROCKY_D2D";

export const START_D2D_EXTRACTION = `${TYPE}/start_d2d_extraction`;